export default __webpack_public_path__ + "static/media/IMG_9988.0ad0ec6a.webp";